import React from 'react'
import { connect } from 'react-redux'
import { Box, useMediaQuery, useTheme, Typography } from '@mui/material'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import CardEstadistica from './CardEstadistica'
import setRedirectUrl from '../../../redux/actions/redirection/setRedirectUrl'
import { IMetricas } from '../../AdminLocal/types'

const Metricas: React.FC<{ metricas: IMetricas }> = ({ metricas }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      sx={{
        marginTop: '10px',
        display: 'grid',
        flexDirection: 'column',
        gap: '0.8rem',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }
      }}
    >
      <CardEstadistica
        logo={<PeopleAltOutlinedIcon />}
        descripcion={
          <Typography variant={isMobile ? 'body1' : 'h6'}>
            Tenés <b>{metricas?.cantSeguidores.toLocaleString()}</b> seguidores
          </Typography>
        }
      />

      <CardEstadistica
        logo={<FavoriteBorderOutlinedIcon />}
        descripcion={
          <Typography variant={isMobile ? 'body1' : 'h6'}>
            <b>{metricas?.cantFavoritosProductos.toLocaleString()}</b> veces marcaron tus productos como favoritos
          </Typography>
        }
      />

      <CardEstadistica
        logo={<RemoveRedEyeOutlinedIcon />}
        descripcion={
          <Typography variant={isMobile ? 'body1' : 'h6'}>
            <b>{metricas?.cantVistasTotales.toLocaleString()}</b> veces entraron a tus publicaciones
          </Typography>
        }
      />

      <CardEstadistica
        logo={<TaskOutlinedIcon />}
        descripcion={
          <Typography variant={isMobile ? 'body1' : 'h6'}>
            <b>{metricas?.cantOfertas.toLocaleString()}</b> publicaciones,{' '}
            {metricas?.cantOfertasVencidas === 0
              ? 'ninguna vencida'
              : `${metricas?.cantOfertasVencidas.toLocaleString()} vencidas`}{' '}
            <b>
              (
              {metricas?.cantOfertasDisp === 0
                ? 'no podés publicar ninguna oferta más'
                : `podés publicar ${metricas?.cantOfertasDisp.toLocaleString()} más`}
              )
            </b>
          </Typography>
        }
      />
      <CardEstadistica
        logo={<ShoppingCartOutlinedIcon />}
        descripcion={
          <Typography variant={isMobile ? 'body1' : 'h6'}>
            <b>{metricas?.cantPedidos.toLocaleString()}</b> pedidos recibidos
          </Typography>
        }
        botonVer="Ver pedidos"
        botonPath="pedidos"
      />
    </Box>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(Metricas)
